import { Accion, AccionEjecutar } from '../types'
import { BaseResponse } from 'src/types'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { SistemaTipo } from "../../../types/enum/enum";
import { getComentarios } from './get-comentarios'
import { getComentariosTipos } from './get-comentarios-tipos'
import { postComentario } from './post-comentario'
import { postArchivo } from './post-archivo'
import { getArchivos } from './get-archivos'
import { getArchivoTipos } from './get-archivo-tipos'
import { getFirmas } from './get-firmas'
import { putFirma } from './put-firma'

const getEndpoint = (url = ''): string => `workflow/${url}`

export const getEndpointBySistema = (codSistema: number) => {
    const ruta = () => {
        switch (codSistema) {
            case SistemaTipo.MinutaCredito:
                return 'wrc'
            case SistemaTipo.MinutaMercado:
                return 'wrm'
            case SistemaTipo.Contrapartes:
                return 'contrapartes'
            case SistemaTipo.CLG:
                return 'clg'
            case SistemaTipo.CLFB:
                return 'clfb'
            case SistemaTipo.Corporate:
                return 'corporate'
            case SistemaTipo.CapitalMarkets:
                return 'capital-markets'
            case SistemaTipo.NotaEstructurada:
                return 'nota-estructurada'
            case SistemaTipo.TransferenciaTerceros:
                return 'transferencia-terceros'
            case SistemaTipo.CorporateLending:
                return 'corporate-lending'
            case SistemaTipo.ControlOperativo:
                return 'control-operativo'
            case SistemaTipo.LEP:
                return 'lep'
            case SistemaTipo.LCLS:
                return 'lcls'
            case SistemaTipo.LCTC:
                return 'lctc'
            case SistemaTipo.AFOPU:
                return 'afopu'
            case SistemaTipo.AFOCL:
                return 'afocl'
            case SistemaTipo.LCSLHPTI:
                return 'lcslhpti'
            case SistemaTipo.NOTES:
                return 'notes'
            case SistemaTipo.ADCM:
                return 'adcm'
            default:
                break
        }
    }

    return `operaciones/${ruta()}`
}

export const HttpSistema = {
    getAcciones: (idEtapa: number): Promise<Accion[]> => {
        return HttpAxiosRequest.get(getEndpoint(`acciones/${idEtapa}`))
    },

    ejecutarAccion: (idMensaje: number, accionEjecutar: AccionEjecutar): Promise<BaseResponse> => {
        return HttpAxiosRequest.post(getEndpoint(`mensaje/${idMensaje}/ejecutar`), accionEjecutar)
    },

    getComentarios: getComentarios,
    getComentariosTipos: getComentariosTipos,
    postComentario: postComentario,
    postArchivo: postArchivo,
    getArchivos: getArchivos,
    getArchivoTipos: getArchivoTipos,
    getFirmas: getFirmas,
    putFirma: putFirma
} as const
